module.exports = __webpack_public_path__ + "static/img/no_data.18c34813.png";